import axios from '@/libs/http'

/**
 * 获取聊天记录
 */
export const privateMessageRecord = ({userId,pageNo,pageSize} = {}) => {
    return axios.request({
        url: '/s/c/private-message-record/privateMessageRecord',
        params: {
            userId,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取聊天记录
 */
export const getPrivateMessageRecord = ({userId, cursor, pageSize} = {}) => {
    return axios.request({
        url: '/s/c/private-message-record/getPrivateMessageRecord',
        params: {
            userId,
            cursor,
            pageSize,
        },
        method: 'get'
    })
}

/**
 * 发送消息
 */
export const sendMessage = ({userId,message} = {}) => {
    return axios.request({
        url: '/s/c/private-message-record/sendMessage',
        params: {
            userId,
            message
        },
        method: 'get'
    })
}

/**
 * 获取头像
 */
export const bothPersonalInfo = ({userId} = {}) => {
    return axios.request({
        url: '/s/c/private-message-record/bothPersonalInfo',
        params: {
            userId
        },
        method: 'get'
    })
}

/**
 * 发送已读
 */
export const read = (userId,ids) => {
    let data = new URLSearchParams()
    data.append("userId",userId);
    data.append("ids",ids)
    return axios.request({
        url: '/s/c/private-message-record/read',
        data,
        method: 'post'
    })
}